export default function getTwilioVideo() {
  return import(/* webpackChunkName: "twilio-video" */ 'twilio-video');
}
